import styled from 'styled-components'
import Link from 'next/link'

const HeaderTextStyled = styled.h1`
  font-family: Rubik, sans-serif;
  font-style: italic;
  font-weight: 700;
  font-size: 50px;
  margin: 10px 30px;
`
const NoUnderlineAnchor = styled.a`
  text-decoration: none;
  cursor: pointer;
`

const Heading = () => (
  <Link href='/'>
    <NoUnderlineAnchor>
      <HeaderTextStyled>
        MASTERMINE
      </HeaderTextStyled>
    </NoUnderlineAnchor>
  </Link>
)

export default Heading
